import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";

import { AppsRatingFilter } from "../../components/filters/AppsRatingFilter/AppsRatingFilter";
import { AppsRatingFilterResult } from "../../components/filters/AppsRatingFilter/AppsRatingFilterResult";
import type { IAppsRatingFilterDescriptionDto } from "../../types/descriptionDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";

import FindAppsRatingFilter from "./RatingFilter";

const createRatingFilter = (rating: IAppsRatingFilterDescriptionDto): SearchFilterInstance => ({
    key: "rating",
    trackingName: "App Rating",
    apiCategory: "appsFilters",
    category: appsFilterCategoryMap.apps,
    title: { key: "si.find_apps.filters.rating.title" },
    tooltipText: { key: "si.find_apps.filters.rating.tooltip" },
    filter: new FindAppsRatingFilter({
        options: rating || {
            numberOfRatingsBuckets: [],
        },
    }),
    filterView: AppsRatingFilter,
    filterResultView: AppsRatingFilterResult,
});

export default createRatingFilter;
